/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Team_Solo_TwoInputs */

const en_platform_team_solo_two = /** @type {(inputs: Platform_Team_Solo_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clients book only your open hours`)
};

const pl_platform_team_solo_two = /** @type {(inputs: Platform_Team_Solo_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podopieczni rezerwują tylko Twoje wolne godziny`)
};

/**
* | output |
* | --- |
* | "Clients book only your open hours" |
*
* @param {Platform_Team_Solo_TwoInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_team_solo_two = /** @type {((inputs?: Platform_Team_Solo_TwoInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Team_Solo_TwoInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_team_solo_two(inputs)
	return en_platform_team_solo_two(inputs)
});